/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_Li2Inputs */

const en_guide_what_is_json_s6_li2 = /** @type {(inputs: Guide_What_Is_Json_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoid <strong>trailing commas</strong>: the last item in an object or array must not have a comma after it`)
};

const ko_guide_what_is_json_s6_li2 = /** @type {(inputs: Guide_What_Is_Json_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>후행 쉼표</strong>를 피하세요: 객체나 배열의 마지막 항목 뒤에 쉼표를 넣으면 안 됩니다`)
};

const ja_guide_what_is_json_s6_li2 = /** @type {(inputs: Guide_What_Is_Json_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>末尾のカンマ</strong>は避けてください: オブジェクトや配列の最後の項目の後にカンマを付けてはいけません`)
};

/**
* | output |
* | --- |
* | "Avoid <strong>trailing commas</strong>: the last item in an object or array must not have a comma after it" |
*
* @param {Guide_What_Is_Json_S6_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_li2 = /** @type {((inputs?: Guide_What_Is_Json_S6_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_li2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_li2(inputs)
	return ja_guide_what_is_json_s6_li2(inputs)
});